export const handleDropPlayer = (player, zone, setCourtPositions, setAvailablePlayers) => {
    setCourtPositions(prev => {
        const updatedPositions = { ...prev };

        // If the zone is occupied, return the existing player to the available list
        if (updatedPositions[zone]) {
            setAvailablePlayers(prevPlayers => [...prevPlayers, updatedPositions[zone]]);
        }

        // Assign the player to the zone
        updatedPositions[zone] = player;
        return updatedPositions;
    });

    // Remove player from available list if they were previously in it
    setAvailablePlayers(prev => prev.filter(p => p.id !== player.id));
};


export const getAvailablePlayers = (players, courtPositions) => {
    const assignedPlayerIds = new Set(Object.values(courtPositions).map(p => p.id));
    return players.filter(player => !assignedPlayerIds.has(player.id));
};

export const isLiberoAllowed = (player, zone) => {
    // ✅ Liberos can only be placed in Zones 5, 6, 1 (Back Row)
    if (player.position === "Libero" && ![5, 6, 1].includes(zone)) {
        return false;
    }
    return true;
};

// Fixed: This should check individual court positions, not both together
export const isLineupComplete = (courtPositions) => {
    if (!courtPositions || typeof courtPositions !== 'object') {
        return false;
    }
    return Object.keys(courtPositions).length === 6;
};

// Fixed: Call isLineupComplete separately for each team
export const canStartMatch = (courtPositionsA, courtPositionsB, servingTeam, liberosA, liberosB) => {
    return (
        isLineupComplete(courtPositionsA) &&
        isLineupComplete(courtPositionsB) &&
        !!servingTeam &&
        Array.isArray(liberosA) && liberosA.length >= 1 &&
        Array.isArray(liberosB) && liberosB.length >= 1
    );
};